import React, {Component} from 'react'

import {
  Typography,
} from 'material-ui'

import LandingPageInfoCard from './LandingPageInfoCard'

import {
  Accent,
  bgWhite,
  Title,
} from '../helper/consts'

const style = {
  infoSection:{
    // maxWidth: '1180px',
    width: '100%',
    padding: '100px auto',
    height: 'min-content',
    // backgroundColor:bgWhite,
    marginRight:'auto',
    marginLeft:'auto',
    background:'radial-gradient(ellipse 100% 100% at 90% 10%, #9271f6, #3f51b5)',
  },
  infoContainer:{
    maxWidth: '1180px',
    display: 'flex',
    justifyContent: 'space-around',
    width: '100%',
    margin: '100px 0px',
    flexWrap: 'wrap',
  },
  infoColumn:{
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '39%',
    width: '39%',
    minWidth: '310px',
    margin: '0 10px',
  },
  infoTitle:{
    textAlign: 'right',
    margin: '10px 10px 20px',
    // color: `${Accent}`,
    color:bgWhite,
    fontWeight:'500',
  },
  brandMark:{
    color: `${Accent}`,
  }
}

export default class LandingPageLearnMore extends Component{
  render(){
    return(
      <section id="learnMore" style={style.infoSection} className="loggedOutBody">
        <div style={style.infoContainer} className="container">
          <div style={style.infoColumn} className="column">
            <Typography style={style.infoTitle} type={'display2'}><span style={style.brandMark} id='titleBrandMark'>{Title}</span> is a fresh way to recruit.</Typography>
            <LandingPageInfoCard icon="notifications_active" title="Recruitment 76% Off" message={`${Title} recruits at just 24% of the cost of traditional recruitment.`} />
            <LandingPageInfoCard icon="monetization_on" title="Rewarding Referrals" message={`Referring the ideal candidate increases the likelihood of a referral reward.`} />
          </div>
          <div style={style.infoColumn} className="column">
            <LandingPageInfoCard icon="group_work" title="Ideal, 2 Connections Away" message={`Research shows the ideal candidate is two connections away from your existing network.`} />
            <LandingPageInfoCard icon="enhanced_encryption" title="Productivity Guaranteed" message={`Referrals work. Satisfaction with the successful candidate is guaranteed.`} />
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LandingPageLearnMore.js